"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M5.618 9.343C5.38 6.455 7.676 3 11.996 3c4.396 0 6.674 3.446 6.377 6.357-.172 1.697-.95 2.88-1.687 3.87q-.165.222-.322.426c-.617.814-1.11 1.464-1.323 2.28a.7.7 0 0 1-.678.522H9.63a.7.7 0 0 1-.673-.508c-.114-.402-.33-.792-.628-1.222a19 19 0 0 0-.595-.8c-.14-.18-.287-.37-.443-.58-.752-1.012-1.528-2.25-1.672-4.002m4.503 5.712h1.175v-3.252l-1.36-2.095a.7.7 0 0 1 1.175-.762l.885 1.364.885-1.364a.7.7 0 1 1 1.175.762l-1.36 2.095v3.252h1.16c.34-.874.906-1.614 1.419-2.284q.149-.194.289-.381c.696-.934 1.283-1.865 1.417-3.175.215-2.116-1.449-4.815-4.985-4.815-3.45 0-5.157 2.703-4.983 4.829.112 1.362.704 2.343 1.4 3.28.122.164.255.337.39.512.233.302.472.613.676.906.24.348.468.72.643 1.128m-1.096 3.067c0-.39.317-.707.708-.707h4.527c.39 0 .707.316.707.707A2.88 2.88 0 0 1 12.09 21h-.187a2.88 2.88 0 0 1-2.878-2.878m1.572.693c.248.467.74.785 1.306.785h.187c.566 0 1.057-.318 1.306-.785z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=LightbulbIcon24.js.map